import { createReducer, on } from '@ngrx/store';
import { AnalyticsConsentDialogState } from './analytics-consent-dialog.state';
import { analyticsConsentDialogStateInitial } from './analytics-consent-dialog.state.initial';
import { AnalyticsConsentDialogActions } from './analytics-consent-dialog.actions';

/**
 * Reducer für den Analytics-Consent-Dialog.
 */
export const analyticsConsentDialogReducers = createReducer(
  analyticsConsentDialogStateInitial,

  on(
    AnalyticsConsentDialogActions.open,
    (state): AnalyticsConsentDialogState => ({
      ...state,
      isOpen: true,
    }),
  ),

  on(
    AnalyticsConsentDialogActions.close,
    (state): AnalyticsConsentDialogState => ({
      ...state,
      isOpen: false,
    }),
  ),

);
